/* ============================================================
   Lagomlo — loyalty.js (Shopify theme)
   Warmth Membership (温暖度会员体系): tier ladder, tierFor(),
   Warmth Points, the warmth summary and the leaderboard ranking
   function. Port of preview/js/auth.js (Warmth Membership block)
   + the ranking core of preview/js/leaderboard.js, adapted to the
   Liquid context.

   Customer data comes from the [data-loyalty-customer] JSON
   attribute rendered by warmth-membership.liquid:
     { email, name, confirmedOrders, tierIndex, creditsBalance, orders: [] }
   The metafields behind it:
     customer.metafields.lagomlo.warmth_confirmed_orders
     customer.metafields.lagomlo.warmth_tier_index
     customer.metafields.lagomlo.credits_balance

   DEMO NOTE: "Confirm receipt" only mirrors the confirmation into
   localStorage ('lagomlo.confirmedReceipts' keyed by email,
   'lagomlo.orders' mirror, 'lagomlo.creditsBalance' like ai-studio.js).
   A Shopify App / backend must actually write the metafields, grant
   real AI-credit rewards and re-rank the leaderboard in production.

   All UI strings come from the #loyaltyI18n JSON blob (locale file).

   Exposed: window.Loyalty
   ============================================================ */
(function (global) {
  'use strict';

  var RECEIPTS_LS = 'lagomlo.confirmedReceipts'; // { emailLower: [orderName, ...] }
  var ORDERS_LS = 'lagomlo.orders';               // demo mirror of orders (status/deliveredAt)
  var CREDITS_LS = 'lagomlo.creditsBalance';      // demo mirror (same key as ai-studio.js)

  function el(id) { return document.getElementById(id); }

  function readLS(key, fallback) {
    try {
      var raw = global.localStorage.getItem(key);
      return raw === null ? fallback : JSON.parse(raw);
    } catch (e) { return fallback; }
  }
  function writeLS(key, value) {
    try { global.localStorage.setItem(key, JSON.stringify(value)); } catch (e) {}
  }

  function escHtml(s) {
    return String(s == null ? '' : s)
      .replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;').replace(/"/g, '&quot;');
  }

  /* ---------- Toast (tiny dependency-free replacement for Store.toast) ---------- */
  function toast(message) {
    var box = document.querySelector('.lagomlo-toasts');
    if (!box) {
      box = document.createElement('div');
      box.className = 'lagomlo-toasts';
      document.body.appendChild(box);
    }
    var t = document.createElement('div');
    t.className = 'lagomlo-toast';
    t.textContent = message;
    box.appendChild(t);
    setTimeout(function () {
      t.classList.add('is-leaving');
      setTimeout(function () { if (t.parentNode) t.parentNode.removeChild(t); }, 300);
    }, 2600);
  }

  /* ---------- i18n (strings rendered by Liquid into #loyaltyI18n) ---------- */
  function i18n() {
    var node = el('loyaltyI18n');
    if (!node) return {};
    try { return JSON.parse(node.textContent) || {}; } catch (e) { return {}; }
  }

  function fmt(tpl, map) {
    var s = String(tpl == null ? '' : tpl);
    Object.keys(map || {}).forEach(function (k) {
      s = s.split('{{ ' + k + ' }}').join(String(map[k]));
    });
    return s;
  }

  function rootEl() { return document.querySelector('[data-loyalty-customer]'); }

  function loginUrl() {
    var routes = (global.Lagomlo && global.Lagomlo.routes) || {};
    return (routes.root || '/') + 'account/login';
  }

  /* ---------- Customer (parsed from the Liquid data attribute) ---------- */
  function customer() {
    var root = rootEl();
    if (!root) return null;
    var raw = root.getAttribute('data-loyalty-customer');
    if (!raw) return null;
    var data = null;
    try { data = JSON.parse(raw); } catch (e) { return null; }
    if (!data || !data.email) return null;
    return data;
  }

  /* ---------- Warmth Membership (tier ladder from the spec / preview) ---------- */
  // Tiers keyed by cumulative confirmed-delivery order count.
  var WARMTH_TIERS = [
    { orders: 1,   name: 'Toasty',     desc: 'Warm & toasty — welcome to the club' },
    { orders: 3,   name: 'Cozy',       desc: 'Comfy cozy member' },
    { orders: 9,   name: 'Snug',       desc: 'Snug as a bug' },
    { orders: 10,  name: 'Hearth',     desc: 'The heart of the hearth' },
    { orders: 15,  name: 'Ember',      desc: 'Glowing ember' },
    { orders: 20,  name: 'Campfire',   desc: 'Gathering around the fire' },
    { orders: 25,  name: 'Flame',      desc: 'Burning bright' },
    { orders: 30,  name: 'Bonfire',    desc: 'A bonfire of warmth' },
    { orders: 50,  name: 'Radiant',    desc: 'Radiating comfort' },
    { orders: 60,  name: 'Sunbeam',    desc: 'Beaming with warmth' },
    { orders: 70,  name: 'Golden Hour',desc: 'The golden hour of Lagomlo' },
    { orders: 100, name: 'Aurora',     desc: 'The Northern Lights of cozy 🏆' }
  ];
  var WARMTH_POINTS_PER_ORDER = 10;

  // Given confirmed order count, return { index, name, desc, orders, next, ordersToNext, isMax }
  function tierFor(confirmedOrders) {
    var idx = 0;
    for (var i = 0; i < WARMTH_TIERS.length; i++) {
      if (confirmedOrders >= WARMTH_TIERS[i].orders) idx = i;
    }
    var t = WARMTH_TIERS[idx];
    var next = idx + 1 < WARMTH_TIERS.length ? WARMTH_TIERS[idx + 1] : null;
    return {
      index: idx,
      name: t.name,
      desc: t.desc,
      orders: t.orders,
      next: next ? next.name : null,
      ordersToNext: next ? next.orders - confirmedOrders : 0,
      isMax: !next
    };
  }

  function pointsFor(confirmedOrders) {
    return (parseInt(confirmedOrders, 10) || 0) * WARMTH_POINTS_PER_ORDER;
  }

  function tierIcon(index) {
    return index >= 9 ? '🏆' : index >= 5 ? '🔥' : index >= 2 ? '☀️' : '🧣';
  }

  /* ---------- Demo confirmations (localStorage mirror of the metafields) ---------- */
  function confirmedSet(email) {
    var receipts = readLS(RECEIPTS_LS, {});
    var key = String(email || '').toLowerCase();
    return (receipts[key] || []).map(function (n) { return String(n).toUpperCase(); });
  }

  function localConfirmedCount(email) {
    return confirmedSet(email).length;
  }

  // Demo credits: base from the metafield, mirrored into localStorage like ai-studio.js.
  function demoCredits() {
    var c = customer();
    var base = c ? (parseInt(c.creditsBalance, 10) || 0) : 0;
    var local = readLS(CREDITS_LS, null);
    if (local === null) { writeLS(CREDITS_LS, base); return base; }
    return Math.max(0, parseInt(local, 10) || 0);
  }

  // Combined warmth summary: metafield base + local demo confirmations.
  function warmthSummary() {
    var c = customer();
    var base = c ? (parseInt(c.confirmedOrders, 10) || 0) : 0;
    var local = c ? localConfirmedCount(c.email) : 0;
    var confirmed = base + local;
    return {
      base: base,
      local: local,
      confirmedOrders: confirmed,
      points: pointsFor(confirmed),
      tier: tierFor(confirmed),
      creditsBalance: demoCredits()
    };
  }

  // Called by the "Confirm receipt" button (frontend demo only).
  //  - records the confirmation per email in localStorage
  //  - marks the matching order 'Delivered' in the lagomlo.orders mirror
  //    (or adds one so the demo leaderboard picks it up)
  //  - grants the 1st/2nd-order AI credit rewards in the demo mirror
  //  - returns { ok, reason?, creditsGranted, tier, summary }
  function confirmDelivery(orderName) {
    var c = customer();
    if (!c) return { ok: false, reason: 'login' };
    var name = String(orderName || '').trim().toUpperCase();
    if (!name) return { ok: false, reason: 'notfound' };
    var key = String(c.email || '').toLowerCase();
    var receipts = readLS(RECEIPTS_LS, {});
    if (!receipts[key]) receipts[key] = [];
    if (receipts[key].indexOf(name) >= 0) return { ok: false, reason: 'already' };
    receipts[key].push(name);
    writeLS(RECEIPTS_LS, receipts);

    // Mirror: mark an existing demo order Delivered, else add one for this customer.
    var orders = readLS(ORDERS_LS, []);
    var touched = false;
    for (var i = 0; i < orders.length; i++) {
      var id = String(orders[i].id || orders[i].name || '').toUpperCase();
      if (id === name) { orders[i].status = 'Delivered'; orders[i].deliveredAt = new Date().toISOString(); touched = true; break; }
    }
    if (!touched) {
      orders.push({ id: name, name: name, email: c.email, status: 'Delivered', deliveredAt: new Date().toISOString(), fromTheme: true });
    }
    writeLS(ORDERS_LS, orders);

    // Demo credit rewards: 1st confirmed order +9, 2nd +10 (mirror only).
    var creditsGranted = 0;
    var localCount = receipts[key].length;
    if (localCount === 1) creditsGranted = 9;
    else if (localCount === 2) creditsGranted = 10;
    if (creditsGranted > 0) {
      var bal = readLS(CREDITS_LS, null);
      writeLS(CREDITS_LS, Math.max(0, (parseInt(bal, 10) || 0)) + creditsGranted);
    }

    var s = warmthSummary();
    return { ok: true, creditsGranted: creditsGranted, tier: s.tier, summary: s };
  }

  /* ---------- Leaderboard ranking (shared with assets/leaderboard.js) ---------- */
  function periodRange(period) {
    var now = new Date();
    var start;
    if (period === 'monthly') {
      start = new Date(now.getFullYear(), now.getMonth(), 1);
    } else if (period === 'quarterly') {
      var q = Math.floor(now.getMonth() / 3);
      start = new Date(now.getFullYear(), q * 3, 1);
    } else { // yearly
      start = new Date(now.getFullYear(), 0, 1);
    }
    return { start: start, end: now };
  }

  function periodLabel(period) {
    var now = new Date();
    if (period === 'monthly') return now.toLocaleDateString('en-US', { month: 'long', year: 'numeric' });
    if (period === 'quarterly') {
      var q = Math.floor(now.getMonth() / 3) + 1;
      return 'Q' + q + ' ' + now.getFullYear();
    }
    return String(now.getFullYear());
  }

  // Ranking from the 'lagomlo.orders' mirror: { email, name, orders, points, tierName, tierIndex }
  function ranking(period) {
    var range = periodRange(period);
    var orders = readLS(ORDERS_LS, []).filter(function (o) {
      if (o.status !== 'Delivered' || !o.deliveredAt) return false;
      var d = new Date(o.deliveredAt);
      return d >= range.start && d <= range.end;
    });
    var byUser = {};
    orders.forEach(function (o) {
      var key = String(o.email || 'guest').toLowerCase();
      if (!byUser[key]) byUser[key] = { email: key, name: o.name || key, orders: 0 };
      byUser[key].orders += 1;
    });
    var list = Object.keys(byUser).map(function (k) {
      var u = byUser[k];
      var tier = tierFor(u.orders);
      return { email: u.email, name: u.name, orders: u.orders, points: pointsFor(u.orders), tierName: tier.name, tierIndex: tier.index };
    });
    list.sort(function (a, b) { return b.orders - a.orders || b.points - a.points; });
    return list;
  }

  /* ---------- Warmth membership section rendering ---------- */
  function progressLabel(s, t) {
    var tier = s.tier;
    if (tier.isMax) return t.progress_max || 'You\'ve reached the top — Aurora tier! 🏆';
    if (tier.ordersToNext > 0) {
      var tpl = tier.ordersToNext === 1
        ? (t.progress_next_one || '{{ count }} more confirmed order to reach {{ tier }}')
        : (t.progress_next_other || '{{ count }} more confirmed orders to reach {{ tier }}');
      return fmt(tpl, { count: tier.ordersToNext, tier: tier.next });
    }
    return t.progress_unlocked || 'Next tier unlocked on your next confirmed order!';
  }

  function tierCardHTML(s, t) {
    var tier = s.tier;
    var pct = tier.isMax ? 100 : Math.min(100, Math.round((s.confirmedOrders / tier.orders) * 100));
    var routes = (global.Lagomlo && global.Lagomlo.routes) || {};
    return (
      '<h3 class="warmth-card__title">' + escHtml(t.card_title || 'Your tier') + '</h3>' +
      '<div class="warmth-tier">' +
      '  <div class="warmth-tier__icon">' + tierIcon(tier.index) + '</div>' +
      '  <div>' +
      '    <div class="warmth-tier__name">' + escHtml(tier.name) + '</div>' +
      '    <div class="warmth-tier__desc">' + escHtml(tier.desc) + '</div>' +
      '  </div>' +
      '</div>' +
      '<div class="warmth-progress" role="progressbar" aria-valuemin="0" aria-valuemax="100" aria-valuenow="' + pct + '" aria-label="' + escHtml(progressLabel(s, t)) + '">' +
      '  <div class="warmth-progress__bar" style="width:' + pct + '%;"></div>' +
      '</div>' +
      '<p class="warmth-progress__label">' + escHtml(progressLabel(s, t)) + '</p>' +
      '<div class="warmth-actions">' +
      '  <a class="btn btn-outline btn-sm" href="' + ((routes.root || '/') + 'pages/leaderboard') + '">' + escHtml(t.leaderboard_link || 'Warmth Leaderboard') + '</a>' +
      '</div>'
    );
  }

  function statsHTML(s, t) {
    return (
      '<div class="warmth-stats">' +
      '  <div class="warmth-stat"><div class="warmth-stat__value">' + s.confirmedOrders + '</div><div class="warmth-stat__label">' + escHtml(t.stats_confirmed_label || 'confirmed orders') + '</div></div>' +
      '  <div class="warmth-stat"><div class="warmth-stat__value">' + s.points + '</div><div class="warmth-stat__label">' + escHtml(t.stats_points_label || 'Warmth Points') + '</div></div>' +
      '  <div class="warmth-stat"><div class="warmth-stat__value">' + s.creditsBalance + '</div><div class="warmth-stat__label">' + escHtml(t.stats_credits_label || 'AI credits') + '</div></div>' +
      '</div>'
    );
  }

  function ordersHTML(c, t) {
    var list = c.orders || [];
    var head = '<h3 class="warmth-card__title">' + escHtml(t.orders_heading || 'Recent orders') + '</h3>';
    if (!list.length) {
      return head + '<p class="text-soft">' + escHtml(t.no_orders || 'No orders yet — your first cozy design is waiting.') + '</p>';
    }
    var mine = confirmedSet(c.email);
    var html = head + '<div class="loyalty-orders">';
    list.forEach(function (o) {
      var already = mine.indexOf(String(o.name).toUpperCase()) >= 0;
      var delivered = !!o.delivered || already;
      var meta = '';
      if (o.date) meta += escHtml(o.date);
      if (o.items) meta += (meta ? ' · ' : '') + escHtml(fmt(o.items === 1 ? (t.items_count_one || '{{ count }} item') : (t.items_count_other || '{{ count }} items'), { count: o.items }));
      if (o.total) meta += (meta ? ' · ' : '') + escHtml(o.total);
      html +=
        '<div class="loyalty-order">' +
        '  <div class="loyalty-order__main">' +
        '    <div class="loyalty-order__id">' + escHtml(o.name) + '</div>' +
        (meta ? '<div class="loyalty-order__meta">' + meta + '</div>' : '') +
        '  </div>' +
        '  <div class="loyalty-order__status">' +
        (delivered
          ? '<span class="loyalty-badge loyalty-badge--delivered">' + escHtml(t.delivered || 'Delivered ✓') + '</span>'
          : '<button type="button" class="btn btn-sage btn-sm" data-loyalty-confirm="' + escHtml(o.name) + '" title="' + escHtml(t.confirm_title || 'Confirm you received this order to earn Warmth Points & AI credits') + '">' + escHtml(t.confirm_btn || 'Confirm receipt') + '</button>') +
        '  </div>' +
        '</div>';
    });
    return html + '</div>';
  }

  function bindConfirm(root) {
    Array.prototype.forEach.call(root.querySelectorAll('[data-loyalty-confirm]'), function (btn) {
      btn.addEventListener('click', function () {
        var t = i18n();
        var res = confirmDelivery(btn.getAttribute('data-loyalty-confirm'));
        if (!res.ok) {
          var reasonMsg = res.reason === 'login' ? (t.toast_login || 'Please sign in to confirm receipt.')
            : res.reason === 'already' ? (t.toast_already || 'This order is already confirmed.')
            : (t.toast_notfound || 'Order not found.');
          toast(reasonMsg);
          if (res.reason === 'login') window.location.href = loginUrl();
          return;
        }
        var msg = fmt(t.toast_confirm || 'Order {{ name }} delivered! +{{ tier }} tier', { name: btn.getAttribute('data-loyalty-confirm'), tier: res.tier.name });
        if (res.creditsGranted > 0) msg += fmt(t.toast_confirm_credits || '· +{{ credits }} AI credits 🎉', { credits: res.creditsGranted });
        toast(msg);
        renderMembership();
      });
    });
  }

  function renderMembership() {
    var tierEl = el('loyaltyTierCard');
    var statsEl = el('loyaltyStats');
    var ordersEl = el('loyaltyOrders');
    if (!tierEl && !statsEl && !ordersEl) return;
    var t = i18n();
    var c = customer();
    if (!c) return; // guests get the Liquid sign-in state
    var s = warmthSummary();
    if (tierEl) tierEl.innerHTML = tierCardHTML(s, t);
    if (statsEl) statsEl.innerHTML = statsHTML(s, t);
    if (ordersEl) ordersEl.innerHTML = ordersHTML(c, t);
    var root = rootEl();
    if (root) bindConfirm(root);
  }

  /* ---------- init ---------- */
  function init() {
    if (!rootEl() && !el('loyaltyTierCard') && !el('loyaltyStats') && !el('loyaltyOrders')) return;
    renderMembership();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  global.Loyalty = {
    WARMTH_TIERS: WARMTH_TIERS,
    WARMTH_POINTS_PER_ORDER: WARMTH_POINTS_PER_ORDER,
    tierFor: tierFor,
    pointsFor: pointsFor,
    tierIcon: tierIcon,
    customer: customer,
    warmthSummary: warmthSummary,
    localConfirmedCount: localConfirmedCount,
    confirmDelivery: confirmDelivery,
    periodRange: periodRange,
    periodLabel: periodLabel,
    ranking: ranking,
    renderMembership: renderMembership,
    init: init
  };
})(window);
